// import router from "../../router";
//import eventBus from "../../../main";
//import jwtDecode from "jwt-decode";

import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    powerNumber: {
      cellphone: Number
    },
    dataset: {
      after: ""
    },
    client: {
      balance: "",
      mcx: {
        openConfirmCreditWallet: false,
        closeSetCreditWallet: true,
        amount: ""
      },
      bank: {
        account: "",
        transaction: {}
      },
      wlt: {
        openConfirmTransWallet: false,
        closeSetTransWallet: true,
        amount: "",
        destiny: "",
        bankToTransfer: "",
        transaction: ""
      }
    }
  },
  mutations: {
    SET_BALANCE_WALLET_CLIENT(state, value) {
      state.client.balance = value;
    },
    SET_BANK_ACCOUNT_CLIENT(state, value) {
      state.client.bank.account = value;
    },
    SET_CONFIRM_CREDIT_WALLET_CLIENT(state, value) {
      state.client.mcx.openConfirmCreditWallet = value.target;
      state.client.mcx.amount = value.amount;
      state.client.mcx.closeSetCreditWallet = value.close;
    },
    SET_CONFIRM_TRANSFER_WALLET_CLIENT(state, value) {
      state.client.wlt.openConfirmTransWallet = value.target;
      state.client.wlt.amount = value.amount;
      state.client.wlt.closeSetTransWallet = value.close;
      state.client.wlt.bankToTransfer = value.ck;
    },

    SET_WALLET_ACCOUNT_NAME_CLIENT(state, value) {
      state.client.wlt.destiny = value;
    },

    SET_TRANSACTIONS_CLIENT(state, value) {
      state.client.bank.transaction = value;
    },
    SET_DATASET_AFTER(state, value) {
      state.dataset.after = value;
    },

    SET_POWER_NUMBER(state, value) {
      state.powerNumber.cellphone = value;
    }
  },
  actions: {
    setDataSetAfter(context, value) {
      context.commit("SET_DATASET_AFTER", value);
    },

    setDataPowerNumber(context, value) {
      context.commit("SET_POWER_NUMBER", value);
    },
    closeDataPin() {
      eventBus.$emit("openTransfer", false);
    },
    setBalanceWalletClient(context, value) {
      context.commit("SET_BALANCE_WALLET_CLIENT", value);
    },
    setConfirmCreditWallet(context, value) {
      context.commit("SET_CONFIRM_CREDIT_WALLET_CLIENT", value);
    },
    setConfirmTransWallet(context, value) {
      context.commit("SET_CONFIRM_TRANSFER_WALLET_CLIENT", value);
      context.commit("SET_WALLET_ACCOUNT_NAME_CLIENT", "");
    },

    //Transfer money to another wallet
    confirmTransferToAnotherWallet(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      const data = {
        ck: value.ck
      };
      apiServices
        .confirmTransferToWallets(data)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_CONFIRM_TRANSFER_WALLET_CLIENT", value);
              context.commit("SET_WALLET_ACCOUNT_NAME_CLIENT", obj.message[0]);
            } else {
              let payload = {
                color: "error",
                right: "center",
                top: "top",
                text: "Ups! Seu pedido não foi processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    //Confirm Transfer to another wallet
    transferToAnotherWallet(context) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .transferToWallets({
          amount: context.getters.getAmountToSetWallet,
          to: context.getters.getBankToTransfer
        })
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              let payload = {
                color: "success",
                right: "center",
                top: "top",
                text: "A sua transferência foi realizada com sucesso!",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                right: "center",
                top: "top",
                text: "Ups! Seu pedido não foi processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    //Charge wallet
    chargeWithWallet(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .chargeWithWallets(JSON.stringify(value))
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              let payload = {
                color: "success",
                text: "Carteira carregada com sucesso",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Verifique as suas credenciais",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center"
            }); // emit the event to the bus
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },
    //Get Bank Account wallet
    getBankAccount(context) {
      //eventBus.$emit("openSpin", true); // emit the event to the bus
      return apiServices
        .getBankAccounts()
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_BALANCE_WALLET_CLIENT", obj.message[0].Saldo);
              context.commit(
                "SET_BANK_ACCOUNT_CLIENT",
                obj.message[0].ContaKyami
              );
            }
          }
        })
        .catch(function() {})
        .finally(function() {
        });
    },

    //Get transactions Billing
    getTransaction(context) {
      return apiServices
        .getTransactions()
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_TRANSACTIONS_CLIENT", obj.message);
            }
          }
        })
        .catch(function() {})
        .finally(function() {
        });
    }
  },

  getters: {
    getBalanceClient(state) {
      return state.client.balance;
    },
    getConfirmCreditWallet(state) {
      return state.client.mcx.openConfirmCreditWallet;
    },
    getBankToTransfer(state) {
      return state.client.wlt.bankToTransfer;
    },
    getAmountToSet(state) {
      return state.client.mcx.amount;
    },
    getAmountToSetWallet(state) {
      return state.client.wlt.amount;
    },
    getNameToTransfer(state) {
      return state.client.wlt.destiny;
    },
    getCloseSetCreditWallet(state) {
      return state.client.mcx.closeSetCreditWallet;
    },
    getBanckAccount(state) {
      return state.client.bank.account;
    },
    getCloseSetTransWallet(state) {
      return state.client.wlt.closeSetTransWallet; //Close Modal trans
    },
    getConfirmTransWallet(state) {
      return state.client.wlt.openConfirmTransWallet; //Confirm trans
    },
    getTransactionToStoryWallet(state) {
      return state.client.bank.transaction;
    },
    getDataSetAfter(state) {
      return state.dataset.after;
    },
    getPowerNumber(state) {
      return state.powerNumber.cellphone;
    }
  }
};
